import { Outlet } from "packages/react-router-dom";
import { useTranslation } from "react-i18next";
import { createComponent } from "utils/libExtend/createComponent";

import { AppSwitchLang } from "../../App/AppSwitchLang.component";
import { SvgImage } from "../SvgImage/SvgImage.component";
import { SFormLayout } from "./FormLayoutStyled/SFormLayout.styled";
import { SFormLayoutFooter } from "./FormLayoutStyled/SFormLayoutFooter.styled";
import { SFormLayoutLogo } from "./FormLayoutStyled/SFormLayoutLogo.styled";

export const FormLayout = createComponent("FormLayout", () => {
  const { t } = useTranslation();
  const isFinOn = process.env.REACT_APP_FIN === "fin";
  const widthImage = isFinOn ? 344 : 250;
  const heightImage = isFinOn ? 50 : 80;
  return (
    <SFormLayout>
      <AppSwitchLang />
      <SFormLayoutLogo finOnWidth={`${widthImage}px`}>
        <SvgImage width={widthImage} height={heightImage} name={isFinOn ? "LogoFin" : "Logo"} />
      </SFormLayoutLogo>
      <Outlet />
      <SFormLayoutFooter>
        {isFinOn ? t("formLayout.topTitle") : t("formLayoutSNGB.topTitle")}
        <br />
        {isFinOn ? t("formLayout.bottomTitle") : t("formLayoutSNGB.bottomTitle")}
      </SFormLayoutFooter>
    </SFormLayout>
  );
});
